import { Injectable } from '@angular/core';
import { Session } from '../types/session';
import { User } from '../types/user';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  adapter = window.localStorage;
  constructor(private router: Router) {}

  set(session: Session): void {
    this.adapter.setItem('token', session.token);
    this.adapter.setItem('user', JSON.stringify(session.user));
  }

  getToken(): string {
    return this.adapter.getItem('token');
  }

  getUser(): User {
    return JSON.parse(this.adapter.getItem('user')) as User;
  }

  setUser(user: User): void {
    this.adapter.setItem('user', JSON.stringify(user));
  }

  getUserRole(): string {
    const user = this.getUser() || { role: '' };
    return user.role;
  }

  destroy(): void {
    this.adapter.removeItem('token');
    this.adapter.removeItem('user');
    this.router.navigateByUrl('/');
  }
}
